import React from "react";

import { type IStudentPayload, type OtherInfoItem, OtherInfoItemTypeEnum } from "../../map-panel-context";

import { DetailsPanelBasicInformation } from "./details-panel-basic-information";
import { EnrollmentAndZoning } from "./enrollment-and-zoning";
import { OtherInfo } from "./other-info";
import { RaceAndEthnicity } from "./race-and-ethnicity";

interface StudentPanelContentProps {
  payload: IStudentPayload | null;
}

const StudentPanelContent: React.FC<StudentPanelContentProps> = React.memo(
  ({ payload }) => {
    const leadingOtherInfo: OtherInfoItem[] = [
      { type: OtherInfoItemTypeEnum.keyValue, label: "Dual Immersion", value: payload?.dualImmersionValue ?? undefined },
      { type: OtherInfoItemTypeEnum.keyValue, label: "ELL", value: payload?.engLangLearnerValue ?? undefined },
    ].filter((item) => Boolean(item.value));

    const otherInfoItems: OtherInfoItem[] = [
      ...leadingOtherInfo,
      ...(payload?.otherInfo ?? []),
    ];

    return (
      <div className="space-y-6 px-3 py-4">
        <DetailsPanelBasicInformation
          address={payload?.address ?? "-"}
          fullName={payload?.fullName ?? "-"}
          grade={payload?.grade ?? "-"}
          id={payload?.id ?? "-"}
        />
        <EnrollmentAndZoning
          attendingSchool={payload?.attendingSchool ?? "-"}
          districtOfResidence={payload?.districtOfResidence ?? "-"}
          newToDistrict={payload?.newToDistrict ?? "-"}
          residenceES={payload?.residenceES ?? "-"}
          residenceHS={payload?.residenceHS ?? "-"}
          residenceMS={payload?.residenceMS ?? "-"}
        />
        <RaceAndEthnicity items={payload?.raceAndEthnicity ?? []} />
        <OtherInfo items={otherInfoItems} />
      </div>
    );
  },
);

export default StudentPanelContent;
